module.exports = __webpack_public_path__ + "static/header-logo-2412577756c325d7a35ad13139e21b35.png";